<form [formGroup]="formGroup">
  <div class="mb-3">
    <label for="organisationId">
      <strong>Select an {{ 'organisation' | ize }}</strong>
    </label>
    <select
      data-dd-action-name="select-integration-register.organisation-select"
      (change)="onOrganisationSelected()"
      class="form-select"
      id="organisationId"
      [class.is-invalid]="
        formGroup.controls.organisationId.touched &&
        formGroup.controls.organisationId.invalid
      "
      formControlName="organisationId"
    >
      <option value="">Create New...</option>
      @for (organisation of organisations; track organisation) {
        <option [value]="organisation.organisationId">
          {{ organisation.name }}
        </option>
      }
    </select>
    @if (isLoadingOrganisations) {
      <div class="input-group-text">
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </div>
    }
  </div>

  @if (formGroup.controls.organisationId.value) {
    <div class="mb-3">
      <label for="registerId"><strong>Select a register</strong></label>
      <div class="input-group mb-3">
        <select
          data-dd-action-name="select-integration-register.register-select"
          class="form-select"
          id="registerId"
          [class.is-invalid]="
            formGroup.controls.registerId.touched &&
            formGroup.controls.registerId.invalid
          "
          formControlName="registerId"
        >
          <option value="">Create New...</option>
          @for (register of registers; track register) {
            <option [value]="register.id">
              {{ register.name }}
            </option>
          }
        </select>
        @if (isLoadingRegisters) {
          <div class="input-group-text">
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
        }
      </div>
    </div>
  }
</form>
